import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthTokenService } from '../services/auth-token.service';
import { Router } from '@angular/router';
import { catchError, from, switchMap, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthTokenService);
  const router = inject(Router); 

  const token = auth.token;

  // ถ้า token หมดอายุ → refresh ก่อน
  if (token && auth.isTokenExpired()) {
    return from(auth.refresh()).pipe(
      switchMap((success) => {

        if (!success) {
          auth.clearTokens();
          router.navigate(['/login']);
          return throwError(() => new Error('Refresh failed'));
        }

        

        const newReq = req.clone({
          setHeaders: { Authorization: `Bearer ${auth.token}` },
        });

        return next(newReq);
      }),
      catchError((err) => {
        auth.clearTokens();
        router.navigate(['/login']);
        return throwError(() => err);
      }),
    );
  }

  // แนบ token ปกติ
  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq);
};
